import { GtagFunction } from '../types';

/**
 * @see https://developers.google.com/gtagjs/reference/api
 */
const gtag: GtagFunction = function () {
    window.dataLayer.push(arguments);
};

window.dataLayer = window.dataLayer || [];
window.gtag = gtag;

export default gtag;
